import React from 'react';
import "../../styles/App.scss";
//components 
import DarkToggle from '../DarkToggle';
import FontToggle from '../FontToggle';
import SoundToggle from '../SoundToggle';
// import SoundButtonPlayer from './SoundButtonPlayer';

function ToggleIconNav({onFontChange,currFont}){
    return(
        <>
            <div className="nav-settings">
                <SoundToggle/>
                <DarkToggle/>
                <FontToggle onFontChange={onFontChange} currFont={currFont}/>
            </div>
        </>
    );
}
export default ToggleIconNav;